/** URL segment for /classes/{levelname}/ and /classes/{levelname}/{class-slug}/ */
export function slugifyCatalogSegment(value: string): string {
  const slug = value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 80);

  return slug;
}

export function matchesCatalogSlug(candidate: string, slug: string): boolean {
  if (!slug?.trim() || !candidate?.trim()) return false;

  const normalized = slug.trim().toLowerCase();
  const candidateLower = candidate.trim().toLowerCase();

  if (candidate === slug || candidateLower === normalized) {
    return true;
  }

  return slugifyCatalogSegment(candidate) === normalized;
}

export function buildClassCatalogPath(
  categorySlug: string,
  courseSlug?: string
): string {
  const category = categorySlug.trim();
  if (!category) return "/classes";

  if (courseSlug?.trim()) {
    return `/classes/${category}/${courseSlug.trim()}`;
  }

  return `/classes/${category}`;
}
